import { Profile } from "../features";

function ProfilePage() {
  return (
    <>
      <Profile.Container />
    </>
  );
}

export default ProfilePage;
